import { mapMutations, mapActions } from "vuex";
export const addPhoneMixin = {
  data() {
    return {
      addPhoneServerReq: false,
      phone: "",
      addPhoneUser: false,
      iOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    };
  },
  methods: {
    ...mapActions("clients", {
      editClient: "editClient",
      addPhone: "addPhone"
    }),
    ...mapActions("selectedPhone", {
      addSelectedPhone: "addSelectedPhone"
    }),
    ...mapActions("favourites", {
      sendAddFavouritesRequest: "sendAddFavouritesRequest",
      sendRemoveFavouritesRequest: "sendRemoveFavouritesRequest"
    }),
    ...mapMutations("chat", {
      setSelectedUserId: "setSelectedUserId"
    }),
    hideAddPhoneUser() {
      this.addPhoneUser = false;
      this.phone = "";
    },
    setPhone() {
      setTimeout(() => {
        const nums = this.phone.split("");
        let newNums = "";
        for (let i = 0; i < nums.length; i++) {
          if (!isNaN(nums[i]) && newNums.length < 12) {
            if (i !== 0 || parseInt(nums[i]) !== 0) {
              if (newNums.length === 3 || newNums.length === 7) {
                newNums += "-";
              }
              newNums += nums[i];
            }
          }
        }
        this.phone = newNums;
      });
    },
    addPhoneLocal(id, by) {
      if (id && by) {
        this.addPhone({
          clientId: id,
          phone: this.phone,
          by: by
        });
      } else {
        this.addPhone({
          clientId: this.clientId.split(".")[1],
          phone: this.phone,
          by: this.by
        });
      }
      this.hideAddPhoneUser();
    },

    /**
     * Function used to add phone only for client.
     *
     * @param id
     * @param by
     * @returns {Promise<void>}
     */
    async addPhoneLocalClientAction(id, by) {
      this.addPhoneServerReq = true;
      this.addPhoneUser = false;
      if (id && by) {
        await this.addPhone({
          clientId: id,
          phone: this.phone,
          by: by
        });
      } else {
        await this.addPhone({
          clientId: this.clientId.split(".")[1],
          phone: this.phone,
          by: this.by
        });
      }
      this.addPhoneServerReq = false;
      this.hideAddPhoneUser();
    }
  }
};
